import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import PNXLabel from "./PNXLabel";
import { classes } from "components/Utility";


interface Props {
  controlProps: controls.OutputControl;
};

const PhoenixOutput = ({
  controlProps,
} : Props) => {

  return <div className={classes(`data-type-${controlProps.dataType || 'string'}`, !controlProps.value && "no-value")}>
    <PNXLabel>{controlProps.label}</PNXLabel>
    {controlProps.value && <div>{controlProps.value}</div>}
  </div>;
};

export default PhoenixOutput;